
const digest = '724c2beefa7d9b356a4c5d5c3de9b7538da97c5e9a26fa7e759f5ecb8196cbc6';
const classes = {"wrapper":"_wrapper_3o99m_1","controls":"_controls_3o99m_11"};
const css = `._wrapper_3o99m_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eaedf3;
  padding: 24px 12px;
  font-size: 14px;
  font-weight: 500;
}
._wrapper_3o99m_1 ._controls_3o99m_11 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  